import MaterialIcon from '@/components/atom/MaterialIcon';
import LinkTag from '@/components/common/link-tag';
import { ROUTES } from '@/types/common';
import { Magazine } from '@/types/magazine';
import { cn } from '@/utils/style';
import { Button } from 'doctornow-design-system';

interface Props {
  simplifiedName?: string;
  magazines?: Magazine[];
  onClickMagazine: (magazine: Magazine) => () => void;
  onClickMore: () => void;
  shouldShowMoreButton: () => boolean;
}

const MedicineGuideMagazine = (props: Props) => {
  return (
    <section className={cn('flex flex-col gap-[20px] px-[24px] py-[28px]')}>
      <h2 className={cn('typography-ui-19sb text-gray-700')}>{props.simplifiedName} 관련 건강 매거진</h2>
      <div className='flex w-full flex-col '>
        {props.magazines?.map((magazine, index, array) => {
          return (
            <>
              <LinkTag
                key={`magazine-${magazine.magazinePid}_${index}`}
                href={`${ROUTES.MAGAZINE.DETAIL.path}/${magazine.magazinePid}`}
                onClickNavigateToScreen={props.onClickMagazine(magazine)}
              >
                <div className='flex w-full items-center justify-between gap-[12px] rounded-[12px] py-[20px]'>
                  <div className='flex flex-col gap-[4px]'>
                    <span className='typography-ui-17sb text-gray-700'>{magazine.title}</span>
                    <span className='typography-ui-15r text-gray-500'>{magazine.description}</span>
                    <span className='typography-ui-13r text-gray-300'>{magazine.createdDate}</span>
                  </div>
                  <div>
                    <img
                      src={magazine.titleImageUrl}
                      alt='magazine-image'
                      className={'h-auto w-[96px] rounded-[8px]'}
                    />
                  </div>
                </div>
              </LinkTag>
              {index < array.length - 1 && <div className='h-[1px] w-full bg-gray-50' />}
            </>
          );
        })}
      </div>
      {props.shouldShowMoreButton() && (
        <Button
          buttonStyle={'outlined'}
          buttonColor='gray'
          size='m'
          className={cn(['w-full transition-all duration-300 ease-in-out', 'hover:scale-[1.02] active:scale-[0.98]'])}
          type='button'
          onClick={props.onClickMore}
        >
          <div className='flex items-center gap-2'>
            <span className='typography-ui-15sb text-gray-600'>더 보기</span>
            <MaterialIcon name={'keyboard_arrow_right'} size={20} />
          </div>
        </Button>
      )}
    </section>
  );
};

export default MedicineGuideMagazine;
